import { createFileRoute } from "@tanstack/react-router"
import { LinkDMComparisonPage } from "@/routes/comparison/linkdm-vs-zapify-pro"

export const Route = createFileRoute("/$lang/comparison/linkdm-vs-zapify-pro")({
  component: LinkDMComparisonPage,
})
